import m from "../../geodata/es2015/centralAfricanRepublicLow";
window.am4geodata_centralAfricanRepublicLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/centralAfricanRepublicLow.js
// module id = null
// module chunks = 